MessageFormat.locale.ca=function(n){return n===1?"one":"other"}
